import React, { useCallback, useEffect, useMemo, useRef } from "react";
import { useLocation } from "react-router-dom";
import { SEPARATOR } from "../misc";
import { Tab, TabContent } from "./Tab";
import { TabData } from ".";
import _ from "lodash";
import { CategorySetDisplay } from "./types";
import { getColor } from "../../themes";
import { event as categoryTabEvent } from "../GA/ProviderInfo/CategoryTab";

export const CategorySetTabDisplay: React.FC<CategorySetDisplay> = ({ categories }) => {
    const { CategoryContent } = require("./CategoryContent");
    const { pathname } = useLocation();
    const ref = useRef<HTMLDivElement>();
    const categoryIds = useMemo(() => {
        return _.join(categories?.map(d => d.tid) ?? [], SEPARATOR);
    }, [categories]);

    const tabData = useMemo<TabData[]>(() => {
        return categories?.map(({ tid, faIcon, theme, displayName }) => {
            return {
                id: `${tid}`,
                title: (
                    <>
                        {faIcon != null && faIcon.toString().trim() !== "" && (
                            <div>
                                <span
                                    className={`${faIcon ?? ""} icon`}
                                    style={{
                                        ...(theme != null && theme.toString().trim() !== ""
                                            ? { color: getColor(theme) }
                                            : {})
                                    }}
                                ></span>

                                {displayName != null && displayName.toString().trim() !== "" && (
                                    <div className="inline-title">{displayName}</div>
                                )}
                            </div>
                        )}
                        {displayName != null && displayName.toString().trim() !== "" && (
                            <div className="title">{displayName}</div>
                        )}
                    </>
                ),
                shortTitle: (
                    <>
                        {faIcon != null && faIcon.toString().trim() !== "" && (
                            <div>
                                <span
                                    className={`${faIcon ?? ""} icon`}
                                    style={{
                                        ...(theme != null && theme.toString().trim() !== ""
                                            ? { color: getColor(theme) }
                                            : {})
                                    }}
                                ></span>
                            </div>
                        )}
                        {/* {displayName != null && displayName.toString().trim() !== "" && (
                            <div className="title">{displayName}</div>
                        )} */}
                    </>
                )
            };
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [categoryIds]);

    const onInvisible = useCallback(() => {
        const tabHeader = ref?.current?.nextElementSibling?.querySelector(".tab-header") as HTMLDivElement;
        // make sure main tab overflow is hidden again
        const pageMainTab = document.querySelector(".page-main-tab") as HTMLDivElement;
        if (pageMainTab) {
            pageMainTab.classList.remove("category-tab-display");
        }

        if (tabHeader) {
            if (tabHeader.classList.contains("sticky-visible")) tabHeader.classList.remove("sticky-visible");
        }
    }, []);
    const onVisible = useCallback(() => {
        const tabHeader = ref?.current?.nextElementSibling?.querySelector(".tab-header") as HTMLDivElement;
        // make sure main tab overflow is unset
        const pageMainTab = document.querySelector(".page-main-tab") as HTMLDivElement;
        if (pageMainTab) {
            pageMainTab.classList.add("category-tab-display");
        }

        if (tabHeader) {
            if (!tabHeader.classList.contains("sticky-visible")) tabHeader.classList.add("sticky-visible");
        }
    }, []);

    const onScroll = useCallback(() => {
        const anchor = ref?.current;

        const tabHeader = ref?.current?.nextElementSibling?.querySelector(".tab-header");
        if (tabHeader && anchor) {
            // const scrollY = window.scrollY ?? 0;
            const panelY = (anchor as Element)?.getBoundingClientRect()?.y ?? 0;
            const panelHeight = (tabHeader as Element)?.getBoundingClientRect()?.height ?? 0;

            if (
                panelY + panelHeight + 0 >= // panelHeight
                -80
            ) {
                window.requestAnimationFrame(onInvisible);
                return;
            }

            window.requestAnimationFrame(onVisible);
        }
    }, [onVisible, onInvisible]);

    useEffect(() => {
        // const newOnScroll = _.debounce(onScroll, 50);
        window.addEventListener("scroll", onScroll, {
            passive: true
        });
        return () => {
            window.removeEventListener("scroll", onScroll);
        };
    }, [onScroll]);

    const onTabActivated = useCallback(
        (tab: TabData) => {
            const anchor = ref?.current;
            if (anchor) {
                // const scrollY = window.scrollY ?? 0;
                const panelY = (anchor as Element)?.getBoundingClientRect()?.y ?? 0;
                window.scrollBy({
                    behavior: "auto",
                    top: panelY
                });
            }

            const category = categories?.find(category => `${category.tid}` === tab.id);
            if (category) categoryTabEvent(pathname, category.displayName, category.displayName);
        },
        [pathname, categories]
    );

    // this effect is to enable the height growth effect from 0 at the start
    // useEffect(() => {
    //     setTimeout(() => {
    //         window.requestAnimationFrame(() => {
    //             const tab = ref?.current?.nextElementSibling;
    //             if (tab && !tab?.classList?.contains("sticky-start")) {
    //                 tab?.classList?.add("sticky-start");
    //             }
    //         });
    //     }, 300);
    // }, []);

    return (
        <>
            <div ref={ref}></div>
            <Tab tabData={tabData} className="sticky-tab">
                {categories?.map((category, index) => {
                    const { tid, catGraphContent } = category;

                    return (
                        <TabContent
                            id={`${tid}`}
                            //key={tid}
                            key={index}
                            onActivated={onTabActivated}
                        >
                            <CategoryContent
                                category={category}
                                graphicElementIds={(catGraphContent ?? []).map(d => d.nid)}
                            />
                        </TabContent>
                    );
                })}
            </Tab>
        </>
    );
};
